// src/pages/ParasutFaturaGonder.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ParasutFaturaGonder.css';

const ParasutFaturaGonder = () => {
  const [kayitlar, setKayitlar] = useState([]);
  const [seciliKayit, setSeciliKayit] = useState(null);
  const [mesaj, setMesaj] = useState('');

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setKayitlar(veriler);
  }, []);

  const handleGonder = async () => {
    if (!seciliKayit) return;

    try {
      const token = localStorage.getItem('parasut_token');

      const payload = {
        data: {
          type: "sales_invoices",
          attributes: {
            description: `Tekliften oluşturulan fatura - ${seciliKayit.firma}`,
            issue_date: new Date().toISOString().split('T')[0],
            due_date: new Date().toISOString().split('T')[0],
            currency: "TRL",
            item_type: "invoice",
            invoice_series: "T",
            invoice_id: `${Date.now()}`,
            contact_name: seciliKayit.firma,
            details: [
              {
                product_name: seciliKayit.model,
                quantity: 1,
                unit_price: 1000
              }
            ]
          },
          relationships: {
            contact: {
              data: {
                id: "YOUR_CONTACT_ID",
                type: "contacts"
              }
            }
          }
        }
      };

      const response = await axios.post(
        'https://api.parasut.com/v4/175236/sales_invoices',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/vnd.api+json'
          }
        }
      );

      setMesaj(`✅ Fatura başarıyla gönderildi: ID ${response.data.data.id}`);
    } catch (error) {
      setMesaj('❌ Fatura gönderilemedi. Hata logunu kontrol edin.');
      console.error(error);
    }
  };

  return (
    <div className="fatura-gonder-container">
      <h2>📤 Paraşüt API - Tekliften Fatura Oluştur</h2>

      <select onChange={(e) => setSeciliKayit(JSON.parse(e.target.value))}>
        <option>-- Firma seçin --</option>
        {kayitlar.map((k, i) => (
          <option key={i} value={JSON.stringify(k)}>
            {k.firma} - {k.model} - {k.seriNo}
          </option>
        ))}
      </select>

      <button onClick={handleGonder}>📨 Paraşüte Fatura Gönder</button>
      {mesaj && <p className="mesaj">{mesaj}</p>}
    </div>
  );
};

export default ParasutFaturaGonder;